import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama tidak boleh kosong!")
});

export default function OrganizationCategoryEditForm({
  onSubmit,
  defaultValues,
  onHide
}) {
  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize={true}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          <div className="form-group row">
            <div className="col-lg-6 col-md-6">
              <Field
                name="name"
                label="Nama"
                component={Input}
                value={values.name}
                placeholder="Nama Category..."
              />
            </div>
          </div>
          <button
            className="btn btn-primary float-right mx-1"
            onClick={handleSubmit}
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
